function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.object.set-prototype-of.js";
import "core-js/modules/es.object.get-prototype-of.js";
import "core-js/modules/es.reflect.construct.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
/*
 *  Best Sellers
 *    Scripts for the Best Sellers section.
 *
 *  Version:
 *    1.0.0 - 2020/02/09
 */

import { register, ShopifySection } from './../ShopifySection';
import * as ResponsiveSizes from './../../settings/Responsive';

//Selectors
export var CONTAINER_SELECTOR = '[data-best-sellers]';
export var COLLECTION_TAB = '[data-best-sellers-tab]';
export var COLLECTION_DESCRIPTION = '[data-best-sellers-description]';
export var CAROUSEL_CONTAINER = '[data-products-carousel-container]';

//Classes
export var CLASS_ACTIVE = 'is-active';
export var ANIMATION_TIMING = 200;

//Attrs
export var DATA_ID = 'data-id';
export var BestSellers = /*#__PURE__*/function (_ShopifySection) {
  _inherits(BestSellers, _ShopifySection);
  var _super = _createSuper(BestSellers);
  function BestSellers(container) {
    var _this;
    _classCallCheck(this, BestSellers);
    _this = _super.call(this, container);
    _this.container = container;
    _this.tab = container.find(COLLECTION_TAB);
    _this.description = container.find(COLLECTION_DESCRIPTION);
    _this.carousel = container.find(CAROUSEL_CONTAINER);
    container.on('click', COLLECTION_TAB, function (e) {
      return _this.onTabClick(e);
    });
    _this.initDescription();
    return _this;
  }
  _createClass(BestSellers, [{
    key: "onTabClick",
    value: function onTabClick(e) {
      e.preventDefault();
      e.stopPropagation();
      var self = $(e.currentTarget);
      if (self.hasClass(CLASS_ACTIVE)) return; //Already Active

      //Find the matching carousel
      var id = self.attr(DATA_ID);
      var carousel = this.container.find("".concat(CAROUSEL_CONTAINER, "[").concat(DATA_ID, "=\"").concat(id, "\"]"));
      var description = self.find(COLLECTION_DESCRIPTION);

      //Swap our classes
      this.carousel.removeClass(CLASS_ACTIVE);
      carousel.addClass(CLASS_ACTIVE);
      this.tab.removeClass(CLASS_ACTIVE);
      self.addClass(CLASS_ACTIVE);
      this.description.removeClass(CLASS_ACTIVE);
      description.addClass(CLASS_ACTIVE);

      //Slide toggle for larger screens
      if ($(window).width() < ResponsiveSizes.large) return;

      //Hide all others
      this.description.each(function (i, e) {
        var desc = $(e);
        if (!desc.hasClass(CLASS_ACTIVE)) desc.slideUp(ANIMATION_TIMING, 'linear');
      });

      //Show the one we now want
      description.slideDown(ANIMATION_TIMING, 'linear');
    }
  }, {
    key: "initDescription",
    value: function initDescription() {
      if ($(window).width() < ResponsiveSizes.large) return;
      this.description.each(function (i, e) {
        var desc = $(e);
        if (desc.hasClass(CLASS_ACTIVE)) desc.slideDown(0);
      });
    }
  }]);
  return BestSellers;
}(ShopifySection);
register(CONTAINER_SELECTOR, BestSellers);